import { render, staticRenderFns } from "./AppsumoCodePage.vue?vue&type=template&id=15dae4b6"
import script from "./AppsumoCodePage.vue?vue&type=script&lang=js"
export * from "./AppsumoCodePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15dae4b6')) {
      api.createRecord('15dae4b6', component.options)
    } else {
      api.reload('15dae4b6', component.options)
    }
    module.hot.accept("./AppsumoCodePage.vue?vue&type=template&id=15dae4b6", function () {
      api.rerender('15dae4b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appsumo-code-page/AppsumoCodePage.vue"
export default component.exports